// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__xJ4WJ","info":"UpdateTermsInfo_info__3i6OR"};